<template>
  <div class="vld-parent" ref="investor_evaluations">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere todos os pitch days em aberto para os fundos de
              investimentos nos quais você participa. Você pode avaliar as
              startups participantes do pitch day e deixar seus comentários.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck">
            <div
              class="col-lg-4 col-md-6 d-flex align-items-stretch"
              v-for="pitchDay in pitchDays"
              :key="'pitch_day_' + pitchDay.id"
            >
              <div class="card card-profile shadow flex-grow-1">
                <div class="row justify-content-center">
                  <div class="col-lg-3 order-lg-2">
                    <div class="card-profile-image">
                      <img
                        src="/img/pages/evaluation.png"
                        class="rounded-circle"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0 mt-7">
                  <div class="text-center mt-5">
                    <h3 class="mt-3">
                      Pitch Day
                      <span class="text-warning">STARS</span>
                    </h3>
                    <div class="row mt-md-3 mb-2">
                      <div class="col text-center text-muted">
                        Pitch Day de startups para
                        <span class="text-warning"
                          >{{ pitchDay.callType }} STARS</span
                        >
                        pertencente à chamada
                        <span class="text-dark font-weight-600">{{
                          pitchDay.callName
                        }}</span
                        >.
                      </div>
                    </div>
                    <h3>
                      Data:
                      <span class="font-weight-light">
                        {{ formatDate(pitchDay.date) }}
                      </span>
                    </h3>
                    <hr class="my-3" />
                    <p class="text-center tag-title">
                      <i class="fas fa-edit mr-1"></i> Você já avaliou
                      <b>{{ pitchDay.countEvaluations }}</b> das
                      <b>{{ pitchDay.countSubscriptions }}</b> startups
                      selecionadas.
                    </p>
                    <base-button
                      type="primary"
                      :custom="true"
                      class="mt-1"
                      @click="handleStartEvaluation(pitchDay.id)"
                      >Avaliar Startups</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Nenhum pitch day vinculado aos seus fundos de investimentos está
                disponível para avaliação no momento.
              </badge>
            </div>
          </div>
          <!-- <hr class="mt-7 mb-1" />
          <div class="col text-right mt-3">
            <base-button type="link" :custom="true"
              >Ver histórico de pitch days</base-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <modal
      :show.sync="showModal"
      :closeOnClick="false"
      modal-classes="modal-warning modal-dialog-centered modal-default"
    >
      <h6 class="modal-title mb-4" id="modal-title-notification">Atenção!</h6>
      <div class="text-center">
        <i class="fa fa-exclamation-circle fa-3x"></i>
        <h4 class="heading mt-4">
          Prezado
          <span class="text-warning text-default-case">investidor</span>,
        </h4>
        <p class="my-4">
          Não há nenhum
          <span class="text-warning font-weight-400">pitch day STARS</span>
          aberto no momento para os fundos de investimentos nos quais você está
          cadastrado. Entraremos em contato caso hajam novos pitch days!
        </p>
        <p class="text-right">
          Cordialmente,<br />
          <span class="font-weight-600"
            >Equipe <span class="text-warning">STARS</span></span
          >.
        </p>
      </div>
      <template slot="footer">
        <base-button type="white" @click="$router.push('/')">
          Voltar ao menu inicial
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "funds",
  data() {
    return {
      pitchDays: [],
      empty: false,
      showModal: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.investor_evaluations,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    try {
      const { data: pitchDays } = await api.get(
        "/investor-pitch-days?only_open=true"
      );
      if (pitchDays.length) this.pitchDays = pitchDays;
      else this.empty = this.showModal = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
  methods: {
    handleStartEvaluation(pitchDayId) {
      this.$router.push(`/investidor/pitch-days/${pitchDayId}/startups`);
    },
  },
};
</script>
<style scoped>
.card {
  margin-top: 10px;
}
.card-profile-image img {
  width: 180px;
  height: 180px;
}
.text-default-case {
  text-transform: none !important;
}
</style>
